import api from "./api";
import { normalize, schema } from "normalizr";
import moment from "moment";
// import { guid } from 'react-agenda';

const defaultReducers = {
  replace(state, payload = {}) {
    return payload;
  },
  mergeArray(state, payload = {}) {
    return [...state, ...payload];
  },
  mergeObject(state, payload = {}) {
    return { ...state, ...payload };
  },
  clear(state) {
    return {};
  },
};

const makesSchema = new schema.Entity("makes");
export const makes = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync({ year }, rootState) {
      try {
        const response = await api.get("/vehicle_makes", { params: { year } });
        if (response && response.status && response.status === 200) {
          this.replace(
            normalize(response.data.data, [makesSchema]).entities.makes
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
  }),
};

const modelsSchema = new schema.Entity("models");
export const models = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync({ year, makeId }, rootState) {
      try {
        const response = await api.get("/vehicle_models", {
          params: { year, make_id: makeId },
        });
        if (response && response.status && response.status === 200) {
          this.replace(
            normalize(response.data.data, [modelsSchema]).entities.models
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
  }),
};

const concernsSchema = new schema.Entity("concerns");
export const concerns = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      try {
        let skills_api_path = "/vehicle_concerns"

        if (window.location.href.indexOf("/mobile") != -1) {
          skills_api_path += "/mobile"
        }

        const response = await api.get(skills_api_path);
        if (response && response.status && response.status === 200) {
          this.mergeObject({
            ...normalize(response.data.data, [concernsSchema]).entities
              .concerns,
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
  }),
  selectors:  (slice, createSelector, hasProps) => ({
    sortedIds() {
      return createSelector(
        state => state.concerns,
        concerns => Object.keys(concerns)
          .sort( (a,b) => concerns[a].attributes.priority - concerns[b].attributes.priority )
      );
    },
  }),
};

const advisorsSchema = new schema.Entity("advisors");
const firstAvailableAdvisor = {
  "0": {
    id: "0",
    type: "advisor",
    attributes: {
      full_name: "First Available",
    },
  }
}

export const advisors = {
  state: window.gon.shoploader_lite ? {} : firstAvailableAdvisor,
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      const concernId = payload ? payload.concernId : null;
      const transportationRequest = payload ? payload.transportationRequest : null;
      try {
        const response = await api.get("/users/advisors", {
          params: {
            concern_id: concernId,
            transportation_request: transportationRequest
          }
        });

        if (response && response.status && response.status === 200) {
          let filteredAdvisorCount = response.data.users.data.length;
          let onlineAdvisorCount = response.data.online_users_count

          let firstAvailable = (filteredAdvisorCount > 1 && onlineAdvisorCount > 1)
            ? firstAvailableAdvisor
            : {}

          this.replace({
            ...firstAvailable,
            ...normalize(response.data.users.data, [advisorsSchema]).entities
              .advisors,
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
  }),
};

export const organization = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      try {
        const response = await api.get("/organization");
        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data &&
          response.data.data
        ) {
          this.mergeObject(response.data.data.attributes);
        }
      } catch (error) {
        console.error(error);
      }
    },
  }),
};

export const decodeVin = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      const toTitleCase = function(str) {
        return str.replace(
          /\w\S*/g,
          function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          }
        );
      }

      const toSnakeCase = function(string) {
        return string.split(' ').map((word) => {
          return word.toLowerCase();
        })
        .join('_');
      }

      try {
        const vin = payload ? payload.vin : null;
        const response = await api.get(`/decode_vin/${vin}`);

        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data
        ) {
          let decodeResponse = { ...response };

          if (response.data.year && response.data.make && response.data.model) {
            // Titleize and add Id for make name
            let data = {
              ...response.data,
              make: toTitleCase(response.data.make),
              makeId: toSnakeCase(response.data.make),
              model: toTitleCase(response.data.model),
              modelId: toSnakeCase(response.data.model)
            }

            decodeResponse = {
              ...decodeResponse,
              data,
              success: true,
              error: null
            }
          }

          this.mergeObject(decodeResponse);
        }
      } catch (error) {
        this.mergeObject({
          success: false,
          error: 'Sorry we could not find your vehicle information using your VIN. Please select your vehicle below.'
        });
      }
    },
  }),
};

export const findVehicle = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      try {
        const phoneNumber = payload ? payload.phoneNumber : null;
        const emailAddress = payload ? payload.emailAddress : null;
        const token = payload ? payload.token : null;

        let requestData = {
          phone_number: phoneNumber,
          email: emailAddress
        };

        // If we have a token that means the user has already
        // verified their ownership of the phone / email,
        // otherwise we need to do a quantity check to see
        // if we need their email address to narrow the search
        if (token) {
          requestData.token = token;
        } else {
          requestData.quantity_check = true;
        }

        const response = await api.post('/find_vehicle', requestData);

        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data
        ) {
          let decodeResponse = {
            ...response,
            searchCompletedAt: (new Date()).getTime()
          };

          if (!response.data.error) {
            decodeResponse = {
              ...decodeResponse,
              vehicles: response.data.vehicles,
              count: response.data.count,
              success: true,
              error: null
            }
          } else {
            decodeResponse = {
              ...decodeResponse,
              vehicles: [],
              count: 0,
              success: false,
              error: response.data.error
            }
          }

          this.mergeObject(decodeResponse);
        }
      } catch (error) {
        this.mergeObject({
          vehicles: [],
          count: 0,
          success: false,
          error: error?.response?.data?.error,
          searchCompletedAt: (new Date()).getTime()
        });
      }
    },
  }),
};

export const createVerification = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      try {
        const phoneNumber = payload ? payload.phoneNumber : null;
        const emailAddress = payload ? payload.emailAddress : null;

        let requestData = {
          phone_number: phoneNumber,
          email: emailAddress,
          method: 'both'
        };

        const response = await api.post('/verifications', requestData);

        if (
          response &&
          response.status &&
          response.status === 201 &&
          response.data
        ) {
          let decodeResponse = {
            ...response,
            verificationSentAt: (new Date()).getTime()
          };

          if (!response.data.error) {
            decodeResponse = {
              ...decodeResponse,
              success: true,
              error: null
            }
          } else {
            decodeResponse = {
              ...decodeResponse,
              success: false,
              error: response.data.error
            }
          }

          this.mergeObject(decodeResponse);
        }
      } catch (error) {
        this.mergeObject({
          success: false,
          error: error?.response?.data?.error,
          verificationSentAt: null
        });
      }
    },
  }),
}

export const updateVerification = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      try {
        const phoneNumber = payload ? payload.phoneNumber : null;
        const verificationCode = payload ? payload.code : null;

        let requestData = {
          phone_number: phoneNumber,
          code: verificationCode
        };

        const response = await api.put(`/verifications/${verificationCode}`, requestData);

        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data
        ) {
          let decodeResponse = {
            ...response,
            verificationUpdatedAt: (new Date()).getTime()
          };

          if (!response.data.error) {
            decodeResponse = {
              ...decodeResponse,
              success: true,
              error: null
            }
          } else {
            decodeResponse = {
              ...decodeResponse,
              success: false,
              error: response.data.error,
              verificationUpdatedAt: null
            }
          }

          this.mergeObject(decodeResponse);
        }
      } catch (error) {
        this.mergeObject({
          success: false,
          error: error?.response?.data?.error,
          verificationUpdatedAt: null
        });
      }
    },
  }),
}

export const skillClassifications = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync(payload, rootState) {
      try {
        let classification_api_path = "/skill_classification"

        if (window.location.href.indexOf("/mobile") != -1) {
          classification_api_path += "/mobile"
        }

        const description = payload ? payload.description : null;
        const response = await api.post(classification_api_path, { description: description });

        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data
        ) {
          let decodeResponse = { ...response };

          if (response.data) {
            let data = [
              ...response.data,
            ]

            decodeResponse = {
              ...decodeResponse,
              data,
              success: true,
              error: null
            }
          }

          this.mergeObject(decodeResponse);
        }
      } catch (error) {
        this.mergeObject({
          success: false,
          error: 'Sorry we could not classify skill.'
        });
      }
    },
  }),
};

const appointmentsSchema = new schema.Entity("appointments");
export const appointments = {
  state: {},
  reducers: { ...defaultReducers },
  effects: (dispatch) => ({
    async fetchAsync({ concernId, advisorId, preferredDate, transportationRequest }, rootState) {
      try {
        const response = await api.get("/find_appointment", {
          params: {
            concern_id: concernId,
            ...(advisorId && advisorId != "0"
              ? { user_id: advisorId }
              : null),
            ...(preferredDate
              ? { preferred_date: moment(preferredDate).format("MM/DD/YYYY") }
              : null),
            ...(transportationRequest
              ? { transportation_request: transportationRequest }
              : null),
          },
        });
        if (response && response.status && response.status === 200) {
          this.replace({
            ...normalize(response.data.data, [appointmentsSchema]).entities
              .appointments,
          });
          dispatch.appointment.mergeObject({
            appointmentSearchCompletedAt: (new Date()).getTime()
          });
          if (
            !preferredDate &&
            Array.isArray(response.data.data) &&
            response.data.data[0] &&
            response.data.data[0].attributes
          )
            dispatch.appointment.mergeObject({
              minDate: moment(
                response.data.data[0].attributes.appointment_date_time
              ).toDate(),
            });
        }
      } catch (error) {
        dispatch.appointment.mergeObject({
          appointmentSearchCompletedAt: (new Date()).getTime()
        });
        console.error(error);
      }
    },
  }),

  selectors: (slice, createSelector, hasProps) => ({
    filteredByAdvisor() {
      return createSelector(
        slice,
        (state, props) => props.advisorId,
        (state, props) => state.advisors,
        (state, props) => state.organization,
        (appointments, advisorId, advisors, organization) => {
          advisorId = String(advisorId);
          let timeslotInterval = organization.timeslot_interval;
          let appointmentDateTime =
            Object.keys(appointments).length > 0 &&
            appointments[Object.keys(appointments)[0]] &&
            appointments[Object.keys(appointments)[0]].attributes &&
            appointments[Object.keys(appointments)[0]].attributes
              .appointment_date_time
              ? appointments[Object.keys(appointments)[0]].attributes
                  .appointment_date_time
              : moment().format();
          let appointmentDateMoment = moment.parseZone(appointmentDateTime);
          let dayOfWeek = appointmentDateMoment
            .clone()
            .format("dddd")
            .toLowerCase();
          let startTimeMoment = organization
            ? moment(organization[`${dayOfWeek}_start`], "h:m a")
            : appointmentDateMoment
                .clone()
                .startOf("day")
                .add(6, "hours")
          let endTimeMoment = organization
            ? moment(organization[`${dayOfWeek}_end`], "h:m a")
            : appointmentDateMoment
                .clone()
                .startOf("day")
                .add(18, "hours")

          // If the timeslot interval is not a 15 minute increment and the start time is not top or :30 past the hour
          // Go to the next beginning of the hour. Ensures incrementing the timeslots by the setting amount produces
          // available timeslots, rather than a list of unavailable timeslots offset by 15 minutes.
          // TODO consider transitioning to showing the slots the backend provides instead
          // of constructing the timeslot intervals here on the frontend too.
          if(timeslotInterval == 30 && (startTimeMoment.minute() != 0 || startTimeMoment.minute() != 30)) {
            startTimeMoment = startTimeMoment.add(1, 'hour').startOf('hour');
          }

          let startTime = startTimeMoment.format("HH:mm:SS.sss");
          let endTime = endTimeMoment.format("HH:mm:SS.sss")
          let startDateTime = String(
            moment(
              `${appointmentDateMoment.format(
                "YYYY-MM-DD"
              )}T${startTime}${appointmentDateMoment.format("Z")}`
            )
              .local()
              .format()
          );
          let endDateTime = String(
            moment(
              `${appointmentDateMoment.format(
                "YYYY-MM-DD"
              )}T${endTime}${appointmentDateMoment.format("Z")}`
            )
              .local()
              .format()
          );

          const timeIndexFormat = "YYYYMMDDTHHmm";
          let filteredAppointments = {};

          for (const id in appointments) {
            const appt = appointments[id];

            if (advisorId != "0" && String(appt.attributes.user_id) != advisorId) {
              continue;
            }

            const appointmentMoment = moment(appt.attributes.appointment_date_time);
            const startTime = String(appointmentMoment.format(timeIndexFormat));
            const startDate = String(appointmentMoment.format("YYYYMMDD"));

            if (
              filteredAppointments[startDate] == null ||
              typeof filteredAppointments[startDate] != "object"
            ) {
              filteredAppointments[startDate] = {};
              let timeIndex = startDateTime;
              const endTime = endDateTime;

              while (moment(timeIndex).isBefore(endTime)) {
                const timeIndexMoment = moment(timeIndex);
                filteredAppointments[startDate][
                  String(timeIndexMoment.clone().format(timeIndexFormat))
                ] = {
                  id: `U_${timeIndex}`,
                  name: `Unavailable`,
                  startDateTime: timeIndexMoment.clone().format("h:mm a"),
                  endDateTime: timeIndexMoment
                    .clone()
                    .add(15, "minutes")
                    .format("h:mm a"),
                  classes: "color-2 color-3",
                  moment: timeIndexMoment.clone(),
                  available: false,
                };
                timeIndex = timeIndexMoment
                  .clone()
                  .add(timeslotInterval, "minutes")
                  .format();
              }
            }
            if (
              typeof filteredAppointments[startDate][startTime] == "object" &&
              filteredAppointments[startDate][startTime] != null &&
              filteredAppointments[startDate][startTime].available == false
            ) {
              const appointmentMoment = moment(appt.attributes.appointment_date_time);
              const technicianMoment = moment(appt.attributes.technician_start_date_time);

              let advisorName = advisors[appt.attributes.user_id] && advisors[appt.attributes.user_id].attributes ?
                advisors[appt.attributes.user_id].attributes.full_name :
                `Unknown (${appt.attributes.user_id})`;

              filteredAppointments[startDate][startTime] = {
                id: appt.id,
                name: `Advisor: ${advisorName}`,
                startDateTime: appointmentMoment.format("h:mm a"),
                endDateTime: appointmentMoment
                  .clone()
                  .add(15, "minutes")
                  .format("h:mm a"),
                technicianId: appt.attributes.technician_id,
                technicianStartDateTime: technicianMoment.format("h:mm a"),
                technicianEndDateTime: technicianMoment
                  .clone()
                  .add(15, "minutes")
                  .format("h:mm a"),
                classes: "color-2 color-3",
                moment: appointmentMoment,
                technicianMoment: technicianMoment,
                available: true,
              };
            }
          }

          return Object.keys(filteredAppointments)
            .sort((a, b) => parseInt(a) - parseInt(b))
            .map((dateIndex) =>
              Object.keys(filteredAppointments[dateIndex])
                .sort((a, b) => a.localeCompare(b))
                .map((timeIndex) => filteredAppointments[dateIndex][timeIndex])
            );
        }
      );
    },
  }),
};

export const appointment = {
  state: {
    year: "",
    make: "",
    model: "",
    vin: "",
    mileage: "",
    name: "",
    email: "",
    phoneNumber: "",
    findPhoneNumber: "",  // field used for customer lookup
    findEmailAddress: "", // field used for customer lookup
    confirmationCode: "", // field used for customer lookup
    verificationToken: "", // field used for customer lookup
    optInConsent: false,
    concern: "",
    concernDetail: "",
    address: "",
    city: "",
    state: "",
    postal_code: "",
    advisor: window.gon.default_advisor_id || "",
    appointment: "",
    concernDescription: "",
    additionalConcerns: "",
    appointmentDate: "",
    technicianDate: "",
    customerNumber: "",
    vehicleId: "",
    potentiallyMatchingSkills: [],
    submitted: false,
    ok: false,
    errorText: "",
    minDate: moment().toDate(),
  },
  reducers: {
    ...defaultReducers,
    replace(state, payload) {
      return { ...payload, submitted: false, ok: false };
    },
    updateResult(state, payload, errorText) {
      return { ...state, submitted: true, ok: payload, errorText: errorText };
    },
  },

  effects: (dispatch) => ({
    async submitAsync(payload, rootState) {
      try {
        let advisor = rootState.appointment.appointment
          ? rootState.appointments[rootState.appointment.appointment].attributes
              .user_id
          : rootState.appointment.advisor
          ? rootState.advisors[rootState.appointment.advisor].attributes
              .user_id
          : "";
        let technician = rootState.appointment.appointment
          ? rootState.appointments[rootState.appointment.appointment].attributes
              .technician_id
          : rootState.appointment.technician
          ? rootState.technicians[rootState.appointment.technician].attributes
              .technician_id
          : "";

        let appointmentBody = {
          vehicle_concern_id: rootState.appointment.concern,
          customer_email: rootState.appointment.email,
          customer_name: rootState.appointment.name,
          customer_phone: rootState.appointment.phoneNumber,
          customer_number: rootState.appointment.customerNumber,
          opt_in_consent: Array.isArray(rootState.appointment.optInConsent) && rootState.appointment.optInConsent[0] == 'on' ? '1' : '',
          vehicle_year: rootState.appointment.year,
          vehicle_make: rootState.appointment.make && rootState.makes[rootState.appointment.make]
            ? rootState.makes[rootState.appointment.make].attributes.make_display
            : rootState.appointment.make,
          vehicle_model: rootState.appointment.model && rootState.models[rootState.appointment.model]
            ? rootState.models[rootState.appointment.model].attributes.model_name
            : rootState.appointment.model,
          vehicle_vin: rootState.appointment.vin,
          vehicle_mileage: rootState.appointment.mileage,
          vehicle_id: rootState.appointment.vehicleId,
          dropoff_starts_at: rootState.appointment.appointment
            ? moment(
                rootState.appointments[rootState.appointment.appointment]
                  .attributes.appointment_date_time
              ).format()
            : "",
          job_starts_at: rootState.appointment.appointment
            ? moment(
                rootState.appointments[rootState.appointment.appointment]
                  .attributes.technician_start_date_time
              ).format()
            : "",
          advisor_id: advisor,
          technician_id: technician,
          vehicle_concern_detail: [
            rootState.appointment.concernDescription,
            rootState.appointment.concernDescriptionAdditionalDetails
          ].filter(Boolean).join("\n"),
          additional_vehicle_concerns:
            rootState.appointment.additionalConcerns,
          rental_requested: rootState.appointment.transportationRequest == 'rentalRequested' ? '1' : '',
          shuttle_requested: rootState.appointment.transportationRequest == 'shuttleRequested' ? '1' : '',
          pickup_requested: rootState.appointment.transportationRequest == 'pickupRequested' ? '1' : '',
          waiter: rootState.appointment.transportationRequest == 'waiter' ? '1' : '',
          self_drop_requested: rootState.appointment.transportationRequest == 'selfDropRequested' ? '1' : '',
          night_drop_requested: rootState.appointment.transportationRequest == 'nightDropRequested' ? '1' : ''
        }

        if(
          rootState.appointment.potentiallyMatchingSkills.length != 0 &&
          !rootState.appointment.potentiallyMatchingSkills.find(skill => skill.id === rootState.appointment.vehicle_concern_id)
        ) {
          appointmentBody.needs_review = "AI skill recommendation skipped. Double check customer skill selection."
        }

        if(rootState.appointment.address) {
          appointmentBody.mobile_service_location = {
            address: rootState.appointment.address,
            suite: rootState.appointment.suite,
            city: rootState.appointment.city,
            state: rootState.appointment.state,
            postal_code: rootState.appointment.postal_code,
            special_instructions: rootState.appointment.special_instructions
          }
        }

        const response = await api.post("/schedule_appointment", appointmentBody);

        if (response && response.status && response.status === 200) {
          this.updateResult(true, '');
        }
      } catch (error) {
        let errorText = error?.response?.data?.errors[0]?.title;
        this.updateResult(false, errorText);
        console.error(error);
      }
    },
  }), // end effects

  selectors: (slice, createSelector, hasProps) => ({
    formatted() {
      return createSelector(
        (state, props) => state.appointment,
        (state, props) => state.appointments,
        (state, props) => state.advisors,
        (state, props) => state.concerns,
        (state, props) => state.makes,
        (state, props) => state.models,
        (appointment, appointments, advisors, concerns, makes, models) => ({
          advisor: appointment.appointment
            ? appointments[appointment.appointment].attributes.user_name
            : appointment.user
            ? advisors[appointment.advisor]?.attributes.user_name
            : "",
          concern: appointment.concern
            ? concerns[appointment.concern].attributes.name
            : "",
          concernDetail: appointment.concernDetail,
          concernDescription: appointment.concernDescription,
          concernDescription: appointment.concernDescription,
          concernDescriptionAdditionalDetails: appointment.concernDescriptionAdditionalDetails,
          concernAttributes: appointment.concern
            ? concerns[appointment.concern].attributes
            : {},
          additionalConcerns: appointment.additionalConcerns,
          rentalRequested: appointment.transportationRequest == 'rentalRequested' ? '1' : '',
          shuttleRequested: appointment.transportationRequest == 'shuttleRequested' ? '1' : '',
          pickupRequested: appointment.transportationRequest == 'pickupRequested' ? '1' : '',
          waiter: appointment.transportationRequest == 'waiter' ? '1' : '',
          selfDropRequested: appointment.transportationRequest == 'selfDropRequested' ? '1' : '',
          nightDropRequested: appointment.transportationRequest == 'nightDropRequested' ? '1' : '',
          date: appointment.appointment
            ? moment(
                appointments[appointment.appointment].attributes
                  .appointment_date_time
              )
            : "",
          year: appointment.year,
          make: appointment.make && makes[appointment.make]
            ? makes[appointment.make].attributes.make_display
            : appointment.make,
          model: appointment.model && models[appointment.model]
            ? models[appointment.model].attributes.model_name
            : appointment.model,
          vin: appointment.vin,
          mileage: appointment.mileage,
          name: appointment.name,
          email: appointment.email,
          phoneNumber: appointment.phoneNumber,
          optInConsent: appointment.optInConsent,
          mobileServiceLocation: (appointment.address
            ? `${appointment.address} ${appointment.suite || ""} ${appointment.city} ${appointment.state} ${appointment.postal_code}`
            : ""),
          specialInstructions: appointment.special_instructions
        })
      );
    },
  }), // end selectors
};
